<template>
    <Menu v-bind="$attrs">
        <Item name="Profile" icon="sr-2 sr-v2-person" :linkUrl="`/athlete/${urlSlug}`" :isActive="true" />
        <Item name="Activity" icon="sr-2 sr-v2-list" :linkUrl="`/athlete/${urlSlug}/activity`" />
        <Item name="Tag Schools" icon="sr-2 sr-v2-tag-filled" :linkUrl="`/athlete/${urlSlug}/tag`" />
        <Item name="Favorite Schools" icon="sr-2 sr-v2-heart-filled" :linkUrl="`/athlete/${urlSlug}/athlete_favorite_schools`" />
        <Item name="Add Commitment" icon="sr-2 sr-v2-mortar-board" :linkUrl="`/athlete/${urlSlug}/add_commitment`" />
    </Menu>
</template>

<script>
import Menu from '@/components/Navbar/SideMenu/Menu'
import Group from '@/components/Navbar/SideMenu/Group'
import Item from '@/components/Navbar/SideMenu/Item'
import { mapGetters } from 'vuex'

export default {
    components: {
        Menu,
        Group,
        Item,
    },

    computed: {
        ...mapGetters('athleteProfile', ['urlSlug']),
    }
}
</script>
